<template>
    <SelectDropDown
            :id="id"
            :name="name"
            @selection-change="regionSelected"
            :options="regions"
            :defaultSelected="regions[0]"
    />
</template>

<script>
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import sharedService from "@/services/shared.service";

    export default {
        name: "RegionDropdown",
        components: {SelectDropDown},
        props: {
            id: String,
            name: String
        },
        created() {
            sharedService.fetchAllRegions()
                .then(({data}) => {
                    this.regions.push({
                        id: 'none',
                        name: '(всички)'
                    });
                    data.forEach(region => this.regions.push(region));
                });
        },
        data() {
            return {
                regions: []
            }
        },
        methods: {
            regionSelected(value) {
                this.$emit('selection-change', {
                    id: value.dropDownId,
                    isDropdown: true,
                    name: value.name,
                    label: value.label,
                    currentValue: value.currentValue.id === 'none' ? '' : value.currentValue.name,
                    oldValue: value.oldValue
                });
            }
        }
    }
</script>

<style scoped>

</style>
